export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    roi: 'ROI',
    roiPercent: 'ROI %',
    wonPercent: 'WON %',
    eCPM: 'eCPM',
};



// WEBPACK FOOTER //
// ./src/scenes/PropellerAdsReport/config.js